import { transformHyphens } from "@bmi-digital/components/utils";
import React from "react";
import ButtonLink from "../components/link/ButtonLink";
import createImageProps from "../components/image/createImageProps";
import createVideoProps from "../components/video/createVideoProps";
import type { HeroProps } from "@bmi-digital/components/hero";
import type { SpotlightHeroProps } from "@bmi-digital/components/spotlight-hero";
import type { Theme } from "@mui/material/styles";
import type { BreadcrumbData } from "../components/Breadcrumbs";
import type { ImageHero } from "../components/image/types";
import type { VideoHero } from "../components/video/types";
import type { LinkData } from "../components/link/types";

type LevelMap = {
  [key: string]: 1 | 2 | 3;
};
const levelMap: LevelMap = {
  "Level 1": 1,
  "Level 2": 2,
  "Level 3": 3
};

export const generateHeroLevel = (
  heroType: string | null,
  enhancedBreadcrumbs: readonly BreadcrumbData[]
): 1 | 2 | 3 | undefined => {
  if (!heroType) {
    return;
  }
  if (heroType == "Spotlight" || heroType == "Hierarchy") {
    return (Math.min(
      enhancedBreadcrumbs.filter(({ slug }) => slug).length,
      3
    ) || 1) as 1 | 2 | 3;
  }
  // eslint-disable-next-line security/detect-object-injection
  return levelMap[heroType];
};

export const generateHeroProps = (
  title: string,
  level: 1 | 2 | 3 | undefined,
  subtitle: string | null,
  featuredVideo: VideoHero | null,
  featuredMedia: ImageHero | null,
  cta: LinkData | null,
  theme: Theme
): HeroProps | SpotlightHeroProps => {
  return {
    title: transformHyphens(title),
    level,
    children: subtitle,
    media: featuredVideo
      ? createVideoProps(featuredVideo, theme)
      : featuredMedia
        ? createImageProps(
            {
              ...featuredMedia,
              size: "cover",
              loading: "eager"
            },
            theme
          )
        : undefined,
    cta: cta ? <ButtonLink data={cta}>{cta.label}</ButtonLink> : undefined
  };
};
